class BESSAppProjectQuestionAnswerDependency extends BESSAppProjectDependency {

    constructor(questionIdentifier, dependencyHandler) {
        super();
        this.questionIdentifier = questionIdentifier;
        this.subscribeToEvents(
            BESSAppQuestionAnswerDependencyEvent.eventFor(this.questionIdentifier),
            (x) => dependencyHandler.handle(x));
    }
}

class BESSAppProjectItemQuestionAnswerDependency extends BESSAppProjectDependency {

    constructor(item, questionIdentifier, dependencyHandler) {
        super();
        this.questionIdentifier = questionIdentifier;
        this.subscribeToEvents(
            BESSAppItemQuestionAnswerDependencyEvent.eventFor(item, this.questionIdentifier),
            (x) => dependencyHandler.handle(x));
    }
}

function questionValueIs(valueIs) {
    if (valueIs[0] === '!') {
        let valueIsNot = valueIs.substring(1);
        let valueIsFn = questionValueIs(valueIsNot);
        return function(x) {
            return !valueIsFn(x);
        }
    }

    return function (value) {
        if (valueIs === '__gt=0') {
            return parseInt(value) > 0;
        }
        return value === valueIs || String(value) === String(valueIs);
    }
}


function questionValueIsAnswered(value) {
    return value !== null && value !== undefined && value !== '';
}

function questionSelectionValueIsAnswered(value) {
    return value !== null && value !== undefined && value !== '' && parseInt(value) >= 0;
}

